__turbopack_context__.v({
  "btn": "graphics-settings-module__sr3qbG__btn",
  "btnWrapper": "graphics-settings-module__sr3qbG__btnWrapper",
  "formContainer": "graphics-settings-module__sr3qbG__formContainer",
  "header": "graphics-settings-module__sr3qbG__header",
  "optionsContainer": "graphics-settings-module__sr3qbG__optionsContainer",
  "optionsToggle": "graphics-settings-module__sr3qbG__optionsToggle",
  "root": "graphics-settings-module__sr3qbG__root",
  "soonBadge": "graphics-settings-module__sr3qbG__soonBadge",
  "subtitle": "graphics-settings-module__sr3qbG__subtitle",
  "title": "graphics-settings-module__sr3qbG__title",
});
